
import './PositionComponentSkeleton.scss';

const PositionComponentSkeleton = () => {

    return (
        <div className='position__wrapper__skeleton'>
            <div className='position__section__desc__wrapper__skeleton'>
                <div className='position__section__text__skeleton'></div>
                <div className='position__section__title__skeleton'></div>
            </div>
            <div className='position__description__wrapper__skeleton'>
                {[...Array(6)].map((_, index) => (
                    <div key={index} className='position__description__wrapper__article__skeleton'></div>
                ))}
                <div className='position__description__wrapper__article__skeleton--primary'></div>
                <div className='position__description__wrapper__subtitle__skeleton'></div>
                {[...Array(10)].map((_, index) => (
                    <div key={index} className='position__description__wrapper__article__skeleton'></div>
                ))}
                <div className='position__description__wrapper__subtitle__skeleton'></div>
                {[...Array(5)].map((_, index) => (
                    <div key={index} className='position__description__wrapper__article__skeleton'></div>
                ))}
                <div className='position__description__wrapper__subtitle__skeleton'></div>
                {[...Array(12)].map((_, index) => (
                    <div key={index} className='position__description__wrapper__article__skeleton'></div>
                ))}
                <div className='position__description__wrapper__subtitle__skeleton'></div>
                {[...Array(2)].map((_, index) => (
                    <div key={index} className='position__description__wrapper__article__skeleton'></div>
                ))}
                <div className="contact__form__row__skeleton">
                    <div className="contact__form__row__item__skeleton">
                        <div className="contact__form__file__input__skeleton"></div>
                        <div className="contact__form__buttons__skeleton"></div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PositionComponentSkeleton;